module.exports = __webpack_public_path__ + "img/98.9.84d9449c.png";